import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";

const vUI_LE_Spend_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_LE_SPEND_ID:           {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Wb Id',
            columnResourceName: 'colwbId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    CONTROL_POINT_ID:         {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Id',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    CONTROL_POINT_NAME:       {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Name',
            columnResourceName: 'colName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 256}
    },
    COMMENTS:                 {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Comments',
            columnResourceName: 'colTreePath',
            alignment: HorizAlignment.Left
        }, domainOptions: {maxLength: 1333}
    },
    MDSET_ID:                 {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Master Data Set Id',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    MDSET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Master Data Set',
            columnResourceName: 'colMDSetName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 256
        }
    },
    CREATED_BY_USER:          {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Created By',
            columnResourceName: 'colCreatedBy',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 256}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Master Data Set WB Id',
            columnResourceName: 'colMDSetId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    WB_SALESAREA_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'wb Sales Area',
            columnResourceName: 'colSalesAreaId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    SALESAREA_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Sales Area Id',
            columnResourceName: 'colSalesAreaId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}
    },
    SALESAREA_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Sales Area',
            columnResourceName: 'colSalesAreaName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
    },
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'wb Sales Org',
            columnResourceName: 'colSalesOrgId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    SALESORG_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'SalesOrg Id', columnResourceName: 'colSalesOrgId', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}
    },
    SALESORG_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Sales Org', columnResourceName: 'colSalesOrgName', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
    },
    WB_COMPANY_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'wb Company',
            columnResourceName: 'colCompanyId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    COMPANY_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Company Id', columnResourceName: 'colCompanyId', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}
    },
    COMPANY_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Company', columnResourceName: 'colCompanyName', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
    }
};

const LESpendSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id:    'WB_LE_SPEND_ID',
        id_ui: 'CONTROL_POINT_ID',
        name:  'CONTROL_POINT_NAME'
    },

    searchProviderFields: vUI_LE_Spend_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_LE_Spend_Search',
                this.searchProviderFields,
                []);

            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                searchRequestSubset.where['WB_MDSET_ID'] = {inq: _.map(usrContext.WB_MasterDataSets, 'WB_MDSET_ID')}
            }

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    },

    // Filter with drop down in the TPM Event Search
    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_LE_Spend_Search',
                this.searchProviderFields,
                [fieldName])

            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                findRequest.where['WB_MDSET_ID'] = {inq: _.map(usrContext.WB_MasterDataSets, 'WB_MDSET_ID')}
            }

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }
};

const LESpendSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "ControlPointSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id',        searchProviderFieldId:  'CONTROL_POINT_ID', renderOptions: {}},
        {profileFilterName: 'Name',      searchProviderFieldId: 'CONTROL_POINT_NAME', renderOptions: {}},
        {profileFilterName: 'Master Data Set', searchProviderFieldId: 'MDSET_NAME', bMultiSelect: true, renderOptions: {}},
        {profileFilterName: 'Company', searchProviderFieldId: 'COMPANY_NAME', bMultiSelect: true, renderOptions: {}},
        {profileFilterName: 'Sales Org', searchProviderFieldId: 'SALESORG_NAME', bMultiSelect: true, renderOptions: {}},
        {profileFilterName: 'Sales Area', searchProviderFieldId: 'SALESAREA_NAME', bMultiSelect: true, renderOptions: {}}

    ], //ISearchFields
    profileDisplayFields: [
        'CONTROL_POINT_ID', 'CONTROL_POINT_NAME', 'MDSET_NAME', 'COMPANY_NAME', 'SALESORG_NAME',
        'SALESAREA_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ],

    profileSearchProvider: LESpendSearchProviderBasic,

    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const LESpendSearch: ISearch = {
    searchName: "Find LE Spend Control Point",
    renderOptions: {ui5ResourceId: "LESpendControlPointSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [LESpendSearchProfileByName]
};

PAEnvironment.registerBusinessObjectSearch("LESpendBO", "LESpend", LESpendSearch, "LE Spend Search")

export {LESpendSearch}
